import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from '@environments/environment';
import { C3AuthService } from '@c3library/services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  if (!environment.securityenabled) {
    console.log('Skipping security, DO NOT GO INTO PRODUCTION WITH THIS.');
    return true;
  }

  const authService = inject(C3AuthService);
  const msalService = inject(MsalService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  const accounts = msalService.instance.getAllAccounts();
  if (accounts.length > 0) {
    return true;
  }

  router.navigate(['/login']);
  return false;
};
